module.exports = __webpack_public_path__ + "media/images/top/ranking-sample04-fd728790d2dc161f62c08242093afeab.jpg";